import App from "./App";
import Product from "./Product";
import Data from "./Data";
import { Link } from "gatsby";

const customshortcodes = { App, Product, Data, Link };

export default customshortcodes;
